export const DEFAULT_ATTENUATION_DISTANCE = 16;
export function computeEffectiveVolume(soundEntryVolume, packetVolume) {
    return soundEntryVolume * Math.max(packetVolume, 0);
}
